function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Christmas = ({
  style,
  ...rest
}) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 511 366",
  style: {
    width: 69,
    height: 52,
    ...style
  }
}, rest), /*#__PURE__*/React.createElement("path", {
  d: "M250.548 61.9467L296.053 136.286C306.427 156.586 306.677 180.582 296.724 201.093L279.987 235.576C268.022 260.235 243.02 275.888 215.613 275.888H155.999C134.638 275.888 114.397 266.348 100.802 249.868L85.161 230.909C75.4495 219.139 70.0148 204.426 69.7341 189.171C68.9934 148.937 83.1571 109.853 109.5 79.4282L124.638 61.9467H250.548Z",
  fill: "url(#paint0_radial)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.387 61.9467L273.488 136.286C281.718 156.586 281.917 180.582 274.018 201.093L260.743 235.576C251.25 260.235 231.418 275.888 209.671 275.888H162.377C145.43 275.888 129.371 266.348 118.588 249.868L106.179 230.909C98.4749 219.139 94.1591 204.426 93.9369 189.171C93.3521 148.937 104.588 109.853 125.485 79.4282L137.496 61.9467H237.387Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.802 249.872L85.161 230.909C75.4496 219.139 70.0149 204.426 69.7342 189.171C68.9934 148.937 83.1572 109.853 109.5 79.4282L124.639 61.9467H219.492L265.001 136.286C275.375 156.586 275.624 180.582 265.667 201.093L248.934 235.576C236.97 260.235 211.968 275.888 184.56 275.888H155.999C134.638 275.888 114.397 266.348 100.802 249.872V249.872Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M100.802 249.872L85.161 230.909C75.4496 219.139 70.0149 204.426 69.7342 189.171C68.9934 148.937 83.1571 109.853 109.5 79.4282L124.639 61.9467H200.018L245.523 136.286C255.901 156.586 256.147 180.582 246.194 201.093L229.461 235.576C217.496 260.235 192.494 275.888 165.087 275.888H155.999C134.638 275.888 114.397 266.348 100.802 249.872V249.872Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.654 5.29192H111.882C115.11 5.29192 117.952 7.68957 118.876 11.1866C119.578 13.8377 121.734 15.6506 124.175 15.6506L122.927 8.93324C122.393 6.04046 124.342 3.31922 126.95 3.31922H142.323C144.268 3.31922 145.948 4.86307 146.346 7.01901C146.744 9.17495 148.424 10.7188 150.369 10.7188H159.375C160.557 7.71686 163.188 5.78705 166.089 5.78705H183.933C187.289 5.78705 190.007 8.86306 190.007 12.6603V16.3952C190.007 18.7071 191.66 20.5823 193.703 20.5823C195.519 20.5823 197.071 19.0814 197.356 17.0463L198.56 8.36404C199.165 4.04046 202.455 0.855286 206.319 0.855286H233.586C236.116 0.855286 238.022 3.46347 237.55 6.27827C237.075 9.09698 238.981 11.7052 241.511 11.7052H243.484C245.671 11.7052 247.609 10.1145 248.291 7.75975C248.973 5.40498 250.915 3.81434 253.102 3.81434H265.383C267.43 3.81434 268.872 6.08724 268.213 8.28217L257.979 58.3522C256.7 62.6407 253.145 65.5218 249.149 65.5218H124.003C120.007 65.5218 116.455 62.6407 115.173 58.3522L105.524 10.2354C104.798 7.81043 106.393 5.29192 108.654 5.29192V5.29192Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.173 58.3522C116.455 62.6407 120.007 65.5257 124.003 65.5257H177.434V5.78705H166.089C163.184 5.78705 160.556 7.72077 159.375 10.7188H150.369C148.424 10.7188 146.744 9.17496 146.346 7.01902C145.948 4.86308 144.268 3.32312 142.323 3.32312H126.95C124.342 3.32312 122.389 6.04046 122.927 8.93324L124.171 15.6506C121.73 15.6506 119.578 13.8377 118.876 11.1905C117.948 7.68958 115.106 5.29582 111.882 5.29582H108.654C106.389 5.29582 104.794 7.81044 105.523 10.2393L115.173 58.3522Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.346 7.01902C145.948 4.86308 144.268 3.32312 142.323 3.32312H126.95C124.342 3.32312 122.393 6.04046 122.927 8.93324L124.175 15.6506C121.73 15.6506 119.578 13.8377 118.876 11.1905C117.952 7.68958 115.106 5.29582 111.882 5.29582H108.654C106.393 5.29582 104.798 7.81044 105.524 10.2393L115.173 58.3561C116.455 62.6407 120.007 65.5257 124.003 65.5257H161.816L159.371 10.7188H150.369C148.424 10.7188 146.744 9.17496 146.346 7.01902V7.01902Z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.654 5.2919C106.393 5.2919 104.798 7.81041 105.524 10.2354L115.173 58.3522C116.455 62.6407 120.007 65.5257 124.003 65.5257H132.346L124.175 15.6505C121.73 15.6505 119.578 13.8377 118.876 11.1866C117.952 7.68955 115.106 5.2919 111.882 5.2919H108.654Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.48 11.7052H241.511C238.981 11.7052 237.075 9.09698 237.547 6.27827C238.022 3.46347 236.116 0.855286 233.586 0.855286H214.455V65.5257H236.576L248.291 7.75975C247.609 10.1145 245.671 11.7052 243.48 11.7052V11.7052Z",
  fill: "url(#paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M219.543 65.5257L225.317 0.855286H206.319C202.455 0.855286 199.161 4.04046 198.56 8.36404L197.352 17.0463C197.305 17.3816 197.223 17.7012 197.11 18.0053L197.032 18.6096L193.488 65.5218H219.543V65.5257Z",
  fill: "url(#paint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.352 17.0463C197.071 19.0814 195.519 20.5823 193.703 20.5823C191.66 20.5823 190.003 18.7071 190.003 16.3952V28.7344C190.003 30.902 191.558 32.6642 193.477 32.6642C195.34 32.6642 196.872 30.9956 196.946 28.8864L197.352 17.0463Z",
  fill: "url(#paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.7342 189.171C68.9934 148.937 83.1572 109.853 109.5 79.4282L124.639 61.9467H250.549L259.932 77.28L259.757 77.6504L94.8062 242.601L85.161 230.909C75.4496 219.139 70.011 204.426 69.7342 189.171V189.171Z",
  fill: "url(#paint11_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.408 77.6504H263.309C266.872 77.6504 269.757 74.7615 269.757 71.2021V61.4633C269.757 57.9039 266.872 55.015 263.309 55.015H110.408C106.849 55.015 103.96 57.9039 103.96 61.4633V71.2021C103.964 74.7615 106.849 77.6504 110.408 77.6504Z",
  fill: "url(#paint12_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M190.857 275.888H213.301L233.145 256.087L233.2 255.958C234.135 255.588 234.927 254.866 235.363 253.872L244.494 232.929L244.728 232.402C245.593 230.402 244.685 228.075 242.685 227.206C240.685 226.332 238.357 227.248 237.488 229.245L237.43 229.369L224.151 242.632L190.857 275.888Z",
  fill: "url(#paint13_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.851 268.254C133.707 273.213 144.697 275.888 155.999 275.888H157.375L231.367 201.958C231.387 201.923 231.398 201.88 231.414 201.837C232.35 201.471 233.145 200.742 233.582 199.748C234.451 197.748 233.539 195.42 231.539 194.547L210.073 185.182C208.077 184.317 205.749 185.225 204.876 187.225C204.86 187.268 204.845 187.307 204.829 187.346L123.851 268.254Z",
  fill: "url(#paint14_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.808 275.888H192.241L220.868 247.311L220.919 247.186C221.851 246.82 222.646 246.09 223.075 245.096L224.151 242.632L232.334 223.864L232.439 223.627C233.313 221.634 232.397 219.307 230.404 218.434C228.404 217.564 226.077 218.473 225.204 220.473L225.149 220.593L169.808 275.888Z",
  fill: "url(#paint15_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.812 219.498L231.367 201.958C231.391 201.923 231.398 201.88 231.414 201.837C232.354 201.471 233.149 200.742 233.582 199.748C234.451 197.748 233.543 195.42 231.543 194.547L223.983 191.252C221.652 195.981 218.977 200.504 215.94 204.843C212.857 209.252 212.217 214.695 213.812 219.498Z",
  fill: "url(#paint16_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.229 236.558C232.151 238.18 234.073 239.794 235.995 241.42C236.786 242.087 237.582 242.761 238.377 243.428C238.751 243.743 239.133 244.04 239.523 244.32L244.494 232.929L244.728 232.402C245.593 230.402 244.685 228.079 242.685 227.206C240.685 226.332 238.357 227.248 237.488 229.245L237.43 229.369L230.229 236.558Z",
  fill: "url(#paint17_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.81 226.933C218.829 226.948 218.849 226.972 218.872 226.987C220.74 228.558 222.607 230.133 224.478 231.712C225.562 232.625 226.642 233.533 227.718 234.445L232.334 223.864L232.439 223.627C233.313 221.634 232.397 219.307 230.404 218.434C228.404 217.564 226.077 218.477 225.204 220.477L225.149 220.597L218.81 226.933Z",
  fill: "url(#paint18_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.163 255.911C232.159 256.78 234.486 255.868 235.359 253.872L244.724 232.402C245.597 230.402 244.681 228.079 242.685 227.206C240.685 226.336 238.361 227.248 237.488 229.244L228.124 250.714C227.25 252.71 228.166 255.038 230.163 255.911Z",
  fill: "url(#paint19_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.582 199.748C234.455 197.748 233.539 195.42 231.543 194.551L210.073 185.186C208.077 184.313 205.749 185.225 204.876 187.225C204.003 189.221 204.919 191.549 206.915 192.422L228.385 201.786C230.385 202.66 232.712 201.744 233.582 199.748Z",
  fill: "url(#paint20_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.882 247.139C219.878 248.009 222.205 247.096 223.079 245.096L232.443 223.63C233.313 221.63 232.4 219.307 230.4 218.434C228.404 217.56 226.077 218.477 225.203 220.473L215.839 241.942C214.97 243.942 215.882 246.266 217.882 247.139Z",
  fill: "url(#paint21_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.88251 298.047C7.63689 295.829 12.4712 297.081 14.6856 300.831L25.3055 318.835C36.5452 337.891 57.2703 349.732 79.395 349.732H124.319V318.207C124.319 313.849 127.851 310.316 132.21 310.316C136.568 310.316 140.1 313.849 140.1 318.207V349.732H326.369V318.207C326.369 313.849 329.901 310.316 334.26 310.316C338.615 310.316 342.147 313.849 342.147 318.207V349.732H385.745V318.207C385.745 313.849 389.277 310.316 393.636 310.316C397.995 310.316 401.527 313.849 401.527 318.207V349.732H431.605C453.729 349.732 474.454 337.895 485.698 318.835L496.314 300.835C498.524 297.081 503.363 295.833 507.117 298.047C510.871 300.258 512.119 305.096 509.905 308.847L499.289 326.85C485.222 350.698 459.289 365.509 431.605 365.509H79.395C51.7108 365.509 25.7772 350.698 11.7148 326.85L1.095 308.851C-1.11942 305.096 0.128136 300.258 3.88251 298.047V298.047Z",
  fill: "url(#paint22_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M235.005 220.551L238.584 235.315C240.888 244.82 249.395 251.51 259.176 251.51H325.702C337.406 251.51 346.891 242.024 346.891 230.321V209.927C346.891 195.974 358.205 184.664 372.154 184.664H372.158C417.823 184.664 458.626 213.194 474.306 256.083L479.636 270.667C489.62 297.977 469.402 326.897 440.326 326.897H71.0714C47.9525 326.897 29.2158 308.157 29.2158 285.038V162.675C29.2158 148.722 40.5257 137.412 54.4788 137.412H129.305C179.5 137.412 223.176 171.767 235.005 220.551V220.551Z",
  fill: "url(#paint23_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.2157 285.038V162.675C29.2157 148.722 40.5256 137.412 54.4787 137.412H129.305C179.504 137.412 223.176 171.767 235.005 220.551L238.584 235.315C240.888 244.82 249.394 251.51 259.176 251.51H325.702C337.406 251.51 346.891 242.024 346.891 230.321V209.927C346.891 195.974 358.205 184.664 372.154 184.664H372.158C374.798 184.664 377.421 184.769 380.026 184.96C379.913 187.946 378.15 190.508 375.608 191.751L354.782 212.995V230.321C354.782 239.26 350.724 247.268 344.357 252.605L270.065 326.897H71.0713C47.9563 326.897 29.2157 308.157 29.2157 285.038V285.038Z",
  fill: "url(#paint24_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.176 259.4H325.702C341.737 259.4 354.782 246.356 354.782 230.321V209.927C354.782 200.348 362.575 192.555 372.158 192.555C376.513 192.555 380.045 189.022 380.045 184.668C380.045 180.309 376.513 176.777 372.158 176.777C353.878 176.777 339.004 191.65 339.004 209.927V230.321C339.004 237.654 333.036 243.623 325.702 243.623H259.176C253.02 243.623 247.702 239.439 246.252 233.455L242.673 218.691C229.948 166.192 183.328 129.525 129.305 129.525H54.4788C50.1201 129.525 46.588 133.054 46.588 137.412C46.588 141.771 50.1201 145.303 54.4788 145.303H129.305C176.018 145.303 216.33 177.011 227.336 222.41L230.915 237.17C234.088 250.258 245.71 259.4 259.176 259.4Z",
  fill: "url(#paint25_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476.817 262.952L479.636 270.667C489.62 297.977 469.402 326.897 440.326 326.897H71.0714C47.9525 326.897 29.2158 308.157 29.2158 285.038V262.952H476.817Z",
  fill: "url(#paint26_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.558 326.897L385.737 342.718V326.897H401.558Z",
  fill: "url(#paint27_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M342.19 326.897L326.369 342.718V326.897H342.19Z",
  fill: "url(#paint28_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.143 326.897L124.319 342.718V326.897H140.143Z",
  fill: "url(#paint29_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.536 206.466L168.208 207.307C158.568 212.961 148.955 218.641 139.289 224.268C138.141 224.789 137.465 226.005 137.622 227.265C137.804 230.631 137.622 230.21 140.383 231.946C141.363 232.719 142.73 232.751 143.744 232.025C152.602 226.766 161.512 221.507 170.37 216.248L171.985 215.327C172.005 215.695 172.005 216.064 171.985 216.432V264.578C172.02 266.212 171.102 267.714 169.641 268.417L139.68 286.324C135.329 288.953 130.952 291.583 126.653 294.212C125.129 295.263 123.123 295.263 121.599 294.212C107.27 285.587 92.9412 277.033 78.6121 268.548C76.9277 267.687 75.906 265.903 76.0068 263.999C76.0068 248.222 76.0068 232.524 76.0068 216.905C76.0068 216.432 76.0068 215.985 76.0068 215.327L77.4397 216.116L118.212 240.045C119.141 240.452 119.7 241.421 119.593 242.437C119.593 254.112 119.593 265.761 119.593 277.436V278.619C119.559 279.399 119.99 280.123 120.687 280.46L122.876 281.696C123.564 282.117 124.428 282.117 125.116 281.696L127.201 280.539C127.952 280.214 128.413 279.441 128.347 278.619C128.347 278.304 128.347 277.988 128.347 277.673V238.02C128.347 237.652 128.347 237.31 128.347 236.942C128.372 236.22 127.988 235.547 127.357 235.206L124.048 233.261L79.9669 207.307L78.6121 206.492L79.7063 205.73L121.391 182.748C122.987 181.751 125.005 181.751 126.601 182.748C140.54 190.479 154.426 198.078 168.312 205.73L169.536 206.466Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(232.306 95.0183) rotate(180) scale(183.934)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF706A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4643",
  stopColor: "#FF6E68"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6626",
  stopColor: "#FD6761"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.8102",
  stopColor: "#FA5A55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.9319",
  stopColor: "#F74943"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F43B36"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: "127.331",
  y1: "126.982",
  x2: "43.1175",
  y2: "73.2962",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: "209.59",
  y1: "111.791",
  x2: "284.855",
  y2: "-0.317965",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: "191.774",
  y1: "102.567",
  x2: "233.88",
  y2: "11.511",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: "238.844",
  y1: "33.1911",
  x2: "130.964",
  y2: "33.1911",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF706A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.8111",
  stopColor: "#F64640"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F43B36"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: "161.533",
  y1: "40.9609",
  x2: "225.367",
  y2: "69.8672",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: "135.439",
  y1: "33.9277",
  x2: "153.832",
  y2: "7.01456",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: "112.132",
  y1: "43.8215",
  x2: "139.82",
  y2: "13.5741",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: "232.009",
  y1: "28.0964",
  x2: "267.646",
  y2: "0.134876",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: "213.163",
  y1: "36.4095",
  x2: "247.541",
  y2: "65.8346",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: "193.679",
  y1: "14.5423",
  x2: "193.679",
  y2: "35.7067",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: "158.375",
  y1: "128.363",
  x2: "217.587",
  y2: "-2.4302",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2352",
  stopColor: "#F03834",
  stopOpacity: "0.235294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4579",
  stopColor: "#E5302D",
  stopOpacity: "0.458824"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6757",
  stopColor: "#D22122",
  stopOpacity: "0.67451"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.8891",
  stopColor: "#B70E12",
  stopOpacity: "0.890196"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: "186.706",
  y1: "60.1741",
  x2: "187.226",
  y2: "80.977",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3E843"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6244",
  stopColor: "#A9C93C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#8DB437"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: "206.224",
  y1: "271.757",
  x2: "284.407",
  y2: "193.574",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: "202.47",
  y1: "214.536",
  x2: "234.05",
  y2: "189.798",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: "195.697",
  y1: "261.23",
  x2: "273.88",
  y2: "183.047",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.436",
  stopColor: "#D02021",
  stopOpacity: "0.435294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: "210.316",
  y1: "216.594",
  x2: "240.317",
  y2: "182.557",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.0029",
  stopColor: "#8DB437",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4813",
  stopColor: "#698927",
  stopOpacity: "0.478431"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#455F18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: "228.829",
  y1: "243.626",
  x2: "258.654",
  y2: "221.521",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.0029",
  stopColor: "#8DB437",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4813",
  stopColor: "#698927",
  stopOpacity: "0.478431"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#455F18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: "215.211",
  y1: "235.882",
  x2: "245.738",
  y2: "212.198",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.0029",
  stopColor: "#8DB437",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4813",
  stopColor: "#698927",
  stopOpacity: "0.478431"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#455F18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: "240.042",
  y1: "243.137",
  x2: "232.805",
  y2: "239.98",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD459"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2296",
  stopColor: "#FFD355"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4362",
  stopColor: "#FFCF4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.634",
  stopColor: "#FFC838"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.825",
  stopColor: "#FFBF1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FFB400"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: "220.807",
  y1: "189.868",
  x2: "217.65",
  y2: "197.105",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD459"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2296",
  stopColor: "#FFD355"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4362",
  stopColor: "#FFCF4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.634",
  stopColor: "#FFC838"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.825",
  stopColor: "#FFBF1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FFB400"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: "227.761",
  y1: "234.365",
  x2: "220.524",
  y2: "231.208",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD459"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2296",
  stopColor: "#FFD355"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4362",
  stopColor: "#FFCF4A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.634",
  stopColor: "#FFC838"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.825",
  stopColor: "#FFBF1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FFB400"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: "255.5",
  y1: "296.95",
  x2: "255.5",
  y2: "365.511",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3E843"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6244",
  stopColor: "#A9C93C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#8DB437"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: "387.523",
  y1: "95.4759",
  x2: "89.8163",
  y2: "393.182",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF706A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.8111",
  stopColor: "#F64640"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#F43B36"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: "379.91",
  y1: "137.412",
  x2: "379.91",
  y2: "326.772",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC0032"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2",
  stopColor: "#D0012D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4",
  stopColor: "#C30229"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6",
  stopColor: "#B70324"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.8",
  stopColor: "#AB041F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#9F041B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: "293.79",
  y1: "95.1407",
  x2: "147.419",
  y2: "241.512",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD459"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.1917",
  stopColor: "#FFD254"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4166",
  stopColor: "#FFCD46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6583",
  stopColor: "#FFC52E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.9103",
  stopColor: "#FFB90E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FFB400"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: "255.716",
  y1: "267.074",
  x2: "255.716",
  y2: "353.162",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F43B36",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.2265",
  stopColor: "#E8322F",
  stopOpacity: "0.227451"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.6362",
  stopColor: "#C81A1C",
  stopOpacity: "0.635294"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#A60108"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear",
  x1: "380.408",
  y1: "340.137",
  x2: "403.124",
  y2: "317.421",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.0029",
  stopColor: "#8DB437",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4813",
  stopColor: "#698927",
  stopOpacity: "0.478431"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#455F18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear",
  x1: "321.041",
  y1: "340.137",
  x2: "343.756",
  y2: "317.421",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.0029",
  stopColor: "#8DB437",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4813",
  stopColor: "#698927",
  stopOpacity: "0.478431"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#455F18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear",
  x1: "118.991",
  y1: "340.137",
  x2: "141.707",
  y2: "317.421",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0.0029",
  stopColor: "#8DB437",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.4813",
  stopColor: "#698927",
  stopOpacity: "0.478431"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#455F18"
}))));

export default Christmas;